import React from "react";
import { useSelector } from "react-redux";
import { DashboardLayout } from "../../layout";
import { NewsBox } from "../../components";
import { RegisterModal, LoginModal, SuccessModal } from "../../components/Forms";
import { NavigationTabs, Header } from "./components";

const SingleForum = () => {
  const { registerModal, loginModal, successModal } = useSelector(({ auth }) => auth);
  return (
    <DashboardLayout page="forums">
      <div className="mt-0">
        <Header />
      </div>
      <div className="mt-10">
        <NavigationTabs />
      </div>
      <div className="mt-0 lg:mt-0">
        <NewsBox />
      </div>
      <RegisterModal show={registerModal} />
      <LoginModal show={loginModal} />
      <SuccessModal show={successModal} />
    </DashboardLayout>
  );
};

export default SingleForum;
